import styled from "styled-components"

import CurrencyLogo from "./CurrencyLogo"


const PanelCurrencyLogo = styled(CurrencyLogo)`
	width: 30px;
	height: 30px;
	display: flex;
	align-self: center;

	/* Tablets */
	@media (max-width: 1400px) {
    	margin-right: 0.3em;
		width: 20px;
		height: 20px;
	}

	/* Mobiles */
	@media (max-width: 640px) {
    	margin-right: 0.2em;
		width: 15px;
		height: 15px;
	}
`;

export default PanelCurrencyLogo